var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { InputWrapper, Input, Label, RequiredLabel, ErrorMessage } from "./Inputs.styled";

var TextField = function TextField(_a) {
  var label = _a.label,
      isRequired = _a.isRequired,
      placeholder = _a.placeholder,
      errorMessage = _a.errorMessage,
      props = __rest(_a, ["label", "isRequired", "placeholder", "errorMessage"]);

  return React.createElement(InputWrapper, {
    hasError: !!errorMessage
  }, React.createElement(Label, {
    mb: 1
  }, label, " ", isRequired && React.createElement(RequiredLabel, {
    as: "span"
  }, "(pole obowi\u0105zkowe)")), React.createElement(Input, __assign({
    required: isRequired,
    placeholder: placeholder
  }, props)), !!errorMessage && React.createElement(ErrorMessage, null, errorMessage));
};

export default TextField;